import { useSWRFetch } from '@hooks/useSWRFetch';
import { FETCH_STATUS } from '@hooks/useSWRFetch/types';
import { ONE_HOUR_IN_MS } from '@helpers/constants';
import { GetEmailAddressResponse__Output } from '@generated/grpc/spotify/s4mpview/v1';

export const useUserEmail = (): {
  data: GetEmailAddressResponse__Output | undefined | null;
  error: string | null;
  status: FETCH_STATUS;
} => {
  const requestObject = {
    url: `catalog/api/useremail`,
    baseUrl: '',
  };

  const { data, error, isValidating, isLoading, ok } =
    useSWRFetch<GetEmailAddressResponse__Output>(requestObject, {
      revalidateOnFocus: false,
      dedupingInterval: ONE_HOUR_IN_MS,
    });

  let status: FETCH_STATUS = FETCH_STATUS.IDLE;

  if (isLoading || isValidating) {
    status = FETCH_STATUS.FETCHING;
  }

  if (error !== null || ok === false) {
    status = FETCH_STATUS.ERROR;
  }

  if (ok && !!data) {
    status = FETCH_STATUS.SUCCESS;
  }

  return {
    data,
    error,
    status,
  };
};
